import { forwardRef, type LabelHTMLAttributes } from 'react';
import { cn } from '~/lib/utils';

const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label ref={ref} className={cn('ui-label', className)} {...props} />
  )
);
Label.displayName = 'Label';

export { Label };
